import { render, staticRenderFns } from "./MarkupLayout.vue?vue&type=template&id=f1ff3798"
import script from "./MarkupLayout.vue?vue&type=script&lang=js"
export * from "./MarkupLayout.vue?vue&type=script&lang=js"
import style0 from "./MarkupLayout.vue?vue&type=style&index=0&id=f1ff3798&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports